/* LeMerch: the cross-sell cards in the cart drawer ("Andere kauften auch") move on by one card every few
   seconds and start over after the last one. A pointer on the slider or a touch pauses the loop; reduced
   motion turns it off. Styles in component-cart-drawer-brand.css. */
(() => {
  if (window.lmCrossSellLoop) return;
  window.lmCrossSellLoop = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const SLIDER = 'cart-drawer cross-sells .scroll-slider__slider';
  const INTERVAL = 3500;
  const PAUSE_AFTER_TOUCH = 8000;
  let pausedUntil = 0;

  const advance = (slider) => {
    const item = slider.querySelector('.cross-sells-item');
    if (!item) return;
    const gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
    const step = item.getBoundingClientRect().width + gap;
    const end = slider.scrollWidth - slider.clientWidth;
    const next = slider.scrollLeft + step > end - 4 ? 0 : slider.scrollLeft + step;
    slider.scrollTo({ left: next, behavior: 'smooth' });
  };

  setInterval(() => {
    if (Date.now() < pausedUntil) return;
    document.querySelectorAll(SLIDER).forEach((slider) => {
      // Only while the drawer is open and the pointer is elsewhere.
      if (!slider.getClientRects().length || slider.matches(':hover')) return;
      if (slider.scrollWidth <= slider.clientWidth) return;
      advance(slider);
    });
  }, INTERVAL);

  document.addEventListener(
    'touchstart',
    (event) => {
      if (event.target.closest && event.target.closest(SLIDER)) pausedUntil = Date.now() + PAUSE_AFTER_TOUCH;
    },
    { passive: true }
  );
})();
